"use client";

import { useSelector } from "react-redux";
import React, { useRef } from "react";

import styles from "./styles.module.scss";

function Header(props) {
  const { isEnrolled, articleInfo } = useSelector((state) => state.video);
  const user = useSelector((state) => state.user.users);

  const headerRef = useRef(null);

  const HeaderTabs = [
    {
      key: 0,
      isVisible: true,
      title: "About",
    },
    {
      key: 1,
      isVisible: true,
      title: "Next Video",
    },
    {
      key: 2,
      isVisible: !articleInfo,
      title: "Comments",
    },
    {
      key: 3,
      isVisible: !articleInfo && user?.email && isEnrolled,
      title: "Notes",
    },
  ];

  return (
    <>
      <header className={styles["header"]} ref={headerRef}>
        {HeaderTabs.map((tab) => {
          if (tab.isVisible)
            return (
              <div
                id={`vd_TabMobile_${tab.title}`}
                key={tab.key}
                onClick={() => props.setActive(tab.title)}
                className={props.active === tab.title ? styles["active"] : ""}
              >
                <h3>{tab.title}</h3>
              </div>
            );
        })}
      </header>
    </>
  );
}

export default Header;
